import { em, math } from 'polished'
import styled from 'styled-components'

const buttonSize = em(23)

export const Wrapper = styled.div`
  padding-bottom: ${em(40)};

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: ${em(20)};
    right: -${em(20)};
    width: 100%;
    height: 3px;
    background: ${p => p.theme.colors.blackOp07};
  }

  ${p => p.theme.mq.upMd} {
    position: absolute;
    top: 0;
    right: 50%;
    transform: translate(50%, 0);
    padding: 0;
    margin: 0;

    &:after {
      content: none;
      display: none;
    }
  }

  ${p => p.theme.mq.upLg} {
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
  }
`

export const InfoButton = styled.button`
  position: absolute;
  display: block;
  top: 50%;
  left: calc(100% + ${em(10)});
  margin-top: ${math(`-${buttonSize} / 2`)};
  width: ${buttonSize};
  height: ${buttonSize};
`

export const TextBox = styled.div`
  display: block;
  line-height: 1.2;
  font-size: ${p => p.theme.typography.textSmallDescr};
  padding-top: ${em(10)};

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(5)};
  }
`
export const ButtonBlock = styled.div`
  &:lang(ja) {
    text-align: right;
  }
`
